import { createApp } from '@backstage/frontend-defaults';
import { SignInPage } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import {
  createFrontendModule,
  microsoftAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { ecosystemMapPlugin } from './modules/ecosystemMap';
import { repositoryMapPlugin } from './modules/repositoryMap';
import { deliveryPolicyGatePlugin } from './modules/deliveryPolicyGate';
import {
  accessControlModule,
  accessControlPlugin,
} from './modules/accessControl';
import { auditCenterPlugin } from './modules/auditCenter';
import { secretScanPlugin } from './modules/secretScan';
import { catalogCodeGraphPlugin } from './modules/codeGraph';
import { governanceAlertsPlugin } from './modules/governanceAlerts';
import { runtimeConfigPlugin } from './modules/runtimeConfig';
import { portalLightThemeOverride } from './theme/portalThemeExtension';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);

      if (configApi.getString('auth.environment') === 'development') {
        return <SignInPage {...props} providers={['guest']} />;
      }

      return (
        <SignInPage
          {...props}
          provider={{
            id: 'microsoft-auth-provider',
            title: 'Microsoft',
            message: 'Entrar com a conta corporativa',
            apiRef: microsoftAuthApiRef,
          }}
        />
      );
    },
  },
});

export default createApp({
  features: [
    catalogPlugin,
    catalogCodeGraphPlugin,
    ecosystemMapPlugin,
    repositoryMapPlugin,
    deliveryPolicyGatePlugin,
    accessControlPlugin,
    auditCenterPlugin,
    governanceAlertsPlugin,
    secretScanPlugin,
    runtimeConfigPlugin,
    navModule,
    accessControlModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage, portalLightThemeOverride],
    }),
  ],
});
